module.exports = __webpack_public_path__ + "static/media/logo_with_text.b47ba151.svg";